export interface IZefixAddress {
    street: string;
    houseNumber?: string;
    zip: string;
    city: string;
    canton: string;
}

export type ZefixCompanyStatus = 'ACTIVE' | 'BEING_CANCELLED' | 'CANCELLED';

export interface IZefixCompanyDTO {
    uid: string;
    name: string;
    legalFormId: string;
    legalFormText: string;
    /**
     * The `name` slug of the matching aumico ILegalForm — e.g. "ag", "gmbh", "cooperative".
     * Language-independent and stable across DB environments. Resolved by the BE via the
     * zefix numeric legalFormId. Use this to match against ILegalFormDTO.name on the FE.
     * Undefined/null when the BE has no mapping for the given zefix legalFormId.
     */
    legalFormAumicoKey?: string;
    address: IZefixAddress;
    status: ZefixCompanyStatus;
    registryOfCommerceId?: string;
}

export interface IZefixDiffField {
    fieldKey: string;
    labelKey: string;
    currentValue: string;
    newValue: string;
    /** The actual value to write to the form control — may differ from newValue for object-type fields like legalform. */
    resolvedValue?: unknown;
}
